import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Status({ status }) {
  let icon = "times";
  let color = "gray";
  switch (status) {
    case "WAITING":
      icon = "inbox";
      color = "orange";
      break;
    case "ARCHIVED":
      icon = "archive";
      color = "#ed3755";
      break;
    case "COMPLETE":
      icon = "check-square";
      color = "#968fff";
      break;
    case "REJECTED":
      icon = "window-close";
      color = "#8444F5";
      break;
    case "SENT":
      icon = "paper-plane";
      color = "#39A2DB";
      break;
    case "CANCELLED":
      icon = "ban";
      color = "#fc0328";
      break;
    default:
      icon = "times";
      color = "gray";
  }

  return (
    <span style={{ marginLeft: "5px" }}>
      <FontAwesomeIcon icon={["fas", icon]} color={color} />
      <span
        style={{
          textTransform: "capitalize",
          marginLeft: "5px",
          fontWeight: "500",
        }}>
        {status?.toLowerCase()}
      </span>
    </span>
  );
}
